import { render, staticRenderFns } from "./ss-banner.vue?vue&type=template&id=245ccda2&scoped=true&"
import script from "./ss-banner.vue?vue&type=script&lang=js&"
export * from "./ss-banner.vue?vue&type=script&lang=js&"
import style0 from "./ss-banner.vue?vue&type=style&index=0&id=245ccda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ccda2",
  null
  
)

export default component.exports